import { remove, removeBulkMile } from '../index';

export const deleteRevision = (data) => {
  return remove(`/revision`, data);
};

export const deleteBulkRevision = (data) => {
  return removeBulkMile(`/revision/bulk`, data);
};
